// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2ppf8","footer":"ChangeClinic_footer__PoNq_"};